
import { i18nText } from '@/locales';

import { Component } from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import { FormMix } from '@/UI/mixins/FormMix';
import { LoyaltySubscriptionStore } from "@/store/modules/Loyalty/Subscription/LoyaltySubscription";
import { IServicesListItem } from "@/entity/services/services.types";
import { SalonsStore } from "@/store/modules/Salons";
import moment from "moment";
import mixins from "@/UI/components/Calendar/mixins/mixins";
import { SubscriptionTableMix } from "@/UI/mixins/Loaylty/SubscriptionTableMix";

@Component({
    components: { PageTitle, }
})
export default class LoyaltySubscriptionCard extends mixins ( FormMix, SubscriptionTableMix ) {
    data_salon: string | undefined = ''
    data_services: IServicesListItem[] | undefined = []

    get sub() {
        return LoyaltySubscriptionStore.loyaltySubscriptions?.data[0]!
    }

    correctData(r: any) {
        return moment(r.created_at).format('DD.MM.YYYY')
    }

    get transactions() {
        return this.sub?.transactions;
    }

    dateActiveTo() {
        let time_date = ''
        if (this.sub.active_to) {
            time_date = moment(this.sub.active_to).format('DD MMMM yyyy') + ' ' + i18nText("в") + ' ' + this.sub.active_to.substr(11, 5)
        }
        return time_date
    }
    dateActiveFrom() {
        let time_date = ''
        if (this.sub.active_from) {
            time_date = moment(this.sub.active_from).format('DD MMMM yyyy') + ' ' + i18nText("в") + ' ' + this.sub.active_from.substr(11, 5)
        }
        return time_date
    }
    dateCreate() {
        let date = ''
        if (this.sub.created_at) {
            date = moment(this.sub.created_at).format('DD MMMM yyyy' + ' ' + i18nText("в") + ' ' + 'HH:mm')
        }
        return date
    }

    async getData() {
        this.data_services = LoyaltySubscriptionStore.loyaltySubscriptions?.data[0]['services']
        await SalonsStore.fetchAll({filter: {id: this.sub.salon_id}})
        this.data_salon = SalonsStore.salons?.data[0].name + 
            ' ' + '(' + 
            moment(this.sub.updated_at).format('DD MMMM yyyy' + 
            ' ' + i18nText("в") + ' ' + 'HH:mm') + ')'
    }

    async created(): Promise<void> {

        console.clear()
        try {
            await LoyaltySubscriptionStore.fetchAll({filter: {id: parseInt(this.$route.params.id)}});
            await this.getData()
        } catch (e) {
            console.error(e)
        } finally {

        }
    }
}
